export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12602.aab56972.jpg";